<template>
    <div class="member_list">
        <div style="display: flex; justify-content: space-between; align-items: center;">
            <div style="color: #515A6E; font-weight: bold; margin-bottom: 20px;">成员</div>
            <Dropdown  trigger="click"
                      style="margin-left: 20px" @on-click="addMember">
                <Button type="primary">+添加成员</Button>
                <DropdownMenu slot="list">
                    <DropdownItem v-for="(role,key) in newRoleList" :name="key">{{role.name}}</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
        <Table :columns="memberColumn" :data="memberList">
            <template slot-scope="{ row }" slot="head">
                <div style="display: flex; align-items: center; height: 60px; ">
                    <img style="width: 50px; height: 50px;border-radius: 50%" :src="row.ext_info.avatar"/>
                </div>
            </template>
            <template slot-scope="{ row }" slot="official">
                <i-switch v-model="row.official" @on-change="change"/>
            </template>
            <template slot-scope="{ row }" slot="operation">
                <div>
                    <div v-if="row.edit == 1" style="display: flex;">
                        <div  class="fill"
                             style="margin-left: 10px;" @click="editRoleClick" :data-role="row.role"
                             :data-department="row.department"
                             :data-name="row.name" :data-id="row.id" :data-phone="row.phone">编辑
                        </div>
                        <div v-if="userInfo.menuList.homePage.organizationMember_removeUser" class="fill"
                             style="margin-left: 10px;" @click="deleteRoleClick" :data-id="row.id"
                             :data-name="row.name">移除
                        </div>
                    </div>
                    <div v-else>
                        --
                    </div>
                </div>
            </template>
        </Table>
        <!-- 添加成员对话框 -->
        <Modal ok-text="确认添加" v-model="addMemberShow" width='400' @on-ok="addOkClick">
            <div style="color: #515A6E; font-weight: bold; margin-bottom: 10px;">添加成员为{{addValue}}</div>
            <Input v-model="addUser['name']" placeholder="请输入姓名" style="width: 300px"/>
            <Input v-model="addUser['phone']" placeholder="请输入手机号" style="width: 300px; margin-top: 10px"/>
            <Input v-model="addUser['password']" placeholder="请输入密码" style="width: 300px; margin-top: 10px"/>
            <!--            <div style="margin-bottom: 5px;">以账号形式添加</div>-->
            <!--            <div v-for="(item,index) in addValueList" :key="index"-->
            <!--                 style="display: flex; align-items: center; justify-content: space-between; margin: 10px 0;">-->
            <!--                <Input v-model="addValueList[index]" placeholder="请输入手机号或账号" style="width: 300px"/>-->
            <!--                <div v-if="index > 0" @click="deleteMemberList" :data-index="index" style="color: #277dd3;"-->
            <!--                     class="icon iconfont icon-jian"></div>-->
            <!--            </div>-->
            <!--            <a @click="addMemberList" style="display: flex;align-items: center;" href="javascript:vold(0)"><span-->
            <!--                    style="color: #277dd3;"-->
            <!--                    class="icon iconfont icon-jia"></span><span>增加成员</span></a>-->
        </Modal>
        <!-- 编辑角色对话框 -->
        <Modal v-model="editMemberShow" width='400' @on-ok="editOkClick">
            <div style="color: #515A6E; font-weight: bold; margin-bottom: 10px;">编辑角色-{{editRoleForm.editNameValue}}
            </div>
            <Form :model="editRoleForm" :label-width="80">
                <FormItem label="所属组织">
                    <Select v-model="editRoleForm.editBranchValue" style="width:200px">
                        <Option v-for="item in departmentList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="角色">
                    <Select v-model="editRoleForm.editRoleValue" style="width:200px">
                        <Option v-for="item in roleList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="密码">
                    <Input v-model="editRoleForm.password" placeholder="如不需要重置密码请留空" style="width: 200px"/>
                </FormItem>
                <FormItem label="账号">
                    <Input v-model="editRoleForm.phone" placeholder="请输入员工登录手机" style="width: 200px"/>
                </FormItem>
            </Form>
        </Modal>
        <!-- 移除对话框 -->
        <Modal ok-text="确认删除" v-model="deleteMemberShow" width='400' @on-ok="deleteOkClick">
            <div style="color: #515A6E; font-weight: bold; margin-bottom: 10px;">删除{{deleteName}}</div>
            <div>确认要将{{deleteName}}删除吗？</div>
        </Modal>
    </div>
</template>

<script>
    import {
        manageUser, deleteUser
    } from '@/api/user'
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "Member",
        props: {
            'roleList': {

            },
            'departmentList': {

            },
            'memberList': {

            },
            department: {
            }
        },
        watch: {
            roleList() {
                let that = this;
                that.newRoleList = [];
                this.roleList.forEach(function (row) {
					
                    if (row.type != 1 && row.type != 3 && row.type != 4 && row.type != 12) {
                        that.newRoleList.push(row);
                    } else if (that.userInfo.role_type == 1 && row.type == 2) {
                        that.newRoleList.push(row);
                    }
                })
            }
        },
        data() {
            return {
                newRoleList: [],
                deleteId: 0,
                deleteName: '',//删除对话框姓名绑定
                deleteMemberShow: false,//删除角色对话框
                branchList: [{
                    value: 'select',
                    label: '请选择'
                },
                    {
                        value: 'beiJingPinLun',
                        label: '北京品伦'
                    },
                ],
                editRoleForm: {
                    id: 0,
                    phone: '',
                    editRoleValue: '', //编辑角色角色绑定
                    editBranchValue: '', //编辑角色部门绑定
                    editNameValue: '', //编辑角色标题绑定
                    password: '', //密码
                },

                editMemberShow: false, //编辑角色对胡框显示
                addUser: {name: '', phone: '', password: ''},
                addValue: '',
                addRoleId: 0,
                addMemberShow: false, //添加成员对话框显示
                // 表格表头数据
                memberColumn: [{
                    title: '头像',
                    // key: 'head',
                    slot: 'head',
                },
                    {
                        title: '姓名',
                        key: 'name'
                    },
                    {
                        title: '账号',
                        key: 'phone'
                    },
                    {
                        title: '部门',
                        key: 'department_name'
                    },
                    {
                        title: '角色',
                        key: 'role_name'
                    },
                    // {
                    // 	title: '官网展示',
                    // 	slot: 'official',
                    // },
                    {
                        title: '加入时间',
                        key: 'created_at'
                    },
                    {
                        title: '操作',
                        // key: 'operation',
                        slot: 'operation'
                    },
                ],
            }
        },
        computed: {
            ...mapGetters(['token', 'userInfo'])
        },
        methods: {
            ...mapActions([
                'handleLogOut',
            ]),
            change(status) {
                this.$Message.success('设置成功');
            },
            // 添加成员按钮
            addMember(e) {
                this.addMemberShow = true
                this.addValue = this.newRoleList[e].name
                this.addRoleId = this.newRoleList[e].id;
            },
            // 添加成员确认添加
            addOkClick() {
                let that = this;
                let data = this.addUser;
                data.token = this.token;
                data.role = this.addRoleId;
                data.department = this.department;
                this.throttle(async function () {
                    let res = await manageUser(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        this.$emit('getMemberList')
                    }
                }, 2000)
            },
            // 增加成员弹出框增加成员按钮
            addMemberList() {
                this.addValueList.push('')
            },
            deleteMemberList(e) {
                let index = e.currentTarget.dataset.index
                this.addValueList.splice(index, 1)
            },
            // 编辑角色确定按钮
            editOkClick() {
                let that = this;
                let data = {
                    token: this.token,
                    id: this.editRoleForm.id,
                    department: this.editRoleForm.editBranchValue,
                    role: this.editRoleForm.editRoleValue,
                    phone: this.editRoleForm.phone,
                    password: this.editRoleForm.password
                };
                this.throttle(async function () {
                    let res = await manageUser(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        this.$emit('getMemberList')
                    }
                }, 2000)
            },
            // 编辑角色按钮点击
            editRoleClick(e) {
                let id = e.currentTarget.dataset.id
                let role = e.currentTarget.dataset.role
                let department = e.currentTarget.dataset.department
                let name = e.currentTarget.dataset.name
                let phone = e.currentTarget.dataset.phone
                this.editMemberShow = true
                this.editRoleForm.id = id;
                this.editRoleForm.phone = phone
                this.editRoleForm.editNameValue = name
                this.editRoleForm.editBranchValue = parseInt(department)
                this.editRoleForm.editRoleValue = parseInt(role)
            },
            //移除按钮点击
            deleteRoleClick(e) {
                this.deleteMemberShow = true
                let id = e.currentTarget.dataset.id
                let name = e.currentTarget.dataset.name
                this.deleteName = name
                this.deleteId = id;
            },
            //删除对跨框确认删除按钮
            deleteOkClick() {
                let that = this;
                let data = {token: this.token, id: this.deleteId};
                this.throttle(async function () {
                    let res = await deleteUser(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        this.$emit('getMemberList')
                    }
                }, 2000)
            }
        }
    }
</script>

<style scoped lang="less">
    .member_list {
        background-color: #FFFFFF;
        width: 1500px;
        margin-left: 10px;
        padding: 20px;
    }

    .fill {
        color: #277dd3;
        cursor: pointer;
    }
</style>
